import { contentModerationSchema } from "../schemas/content-moderation";
import { fetchApi, fetchVoid, paginatedSchema } from "./internal";

export const contentModeration = {
	list: (page = 1) =>
		fetchApi(`/admin/moderation/content?page=${page}`, paginatedSchema(contentModerationSchema)),
	// dismiss: clear a pending item, or restore (unhide) an auto_hidden one.
	dismiss: (id: string) =>
		fetchVoid(`/admin/moderation/content/${id}`, {
			method: "PATCH",
			body: JSON.stringify({ status: "dismissed" }),
		}),
	// action: hide a pending item, or confirm the block on an auto_hidden one.
	action: (id: string) =>
		fetchVoid(`/admin/moderation/content/${id}`, {
			method: "PATCH",
			body: JSON.stringify({ status: "actioned" }),
		}),
};
